const capitalizeFirstLetterString = (string) => {
  if (typeof string !== 'string') {
    return ''
  }
  const firstLetter = 0
  const secondLetter = 1

  if (string.indexOf(' ') >= firstLetter) {
    const splitStr = string.toLowerCase().split(' ')
    const firstWord = (splitStr[firstLetter].charAt(firstLetter).toUpperCase()+splitStr[firstLetter].substring(secondLetter))
    splitStr.shift()
    return `${firstWord } ${ splitStr.join(' ')}`
  }
  return string.charAt(firstLetter).toUpperCase() + string.slice(secondLetter).toLowerCase()
}

export default capitalizeFirstLetterString
